import { useState } from "react";
import { Col, message, Row } from "antd";
import { useHistory, useParams } from "react-router-dom";

import "./companyUsers.less";
import { getColumns } from "./config";
import Button from "@components/Button";
import Table from "@components/Table";
import {
  ErrorServices,
  useFetchCompanyUsersQuery,
  useUpdateCompanyUserStatusMutation,
} from "@services";
import { useTypedSelector } from "@hooks";
import { paths, permissions } from "@router";
import { checkPermission } from "@utils";

const CompanyUsers = () => {
  const history = useHistory();
  const params: { company_id: string } = useParams();
  const paramsCompanyId = params.company_id;
  const [page, setPage] = useState(1);
  const { user, permissions: per } = useTypedSelector(state => state.auth);
  const { id: company_id } = user?.company || { id: paramsCompanyId };

  const [updateCompanyUserStatus] = useUpdateCompanyUserStatusMutation();
  const [pageSize, setPageSize] = useState(10); // ✅ Add pageSize state

  const { data, isLoading } = useFetchCompanyUsersQuery({
    company_id,
    page,
    page_size: pageSize,
  });
  const { data: users, pagination } = data || {};

  const updateCompanyUser = (id: number) =>
    history.push(`/company-users/edit/${id}/company/${company_id}`);

  const updateStatus = async (
    user_id: number,
    name: string,
    is_active: boolean
  ) => {
    try {
      await updateCompanyUserStatus({
        company_id,
        user_id,
        is_active,
      }).unwrap();
      message.success(`${name} is ${is_active ? "active" : "inactive"}`);
    } catch (err: any) {
      ErrorServices(err);
    }
  };

  const columns = getColumns({
    updateStatus,
    id: user?.id!,
    updateCompanyUser,
  });
  console.log("per : ", per);

  return (
    <div className="sub-admins">
      <Row className="mb-20">
        <Col span={16}>
          <div className="main-heading">Company-Users</div>
        </Col>
        <Col className="align-end" span={8}>
          {(per.includes("CREATE_COMPANY_USER") || per.includes("all")) && (
            <Button
              variant="add"
              onClick={() =>
                history.push(
                  `${paths.client.users.company_users.company_user}/create/${company_id}`
                )
              }
            >
              Create Company User
            </Button>
          )}
        </Col>
      </Row>
      <Table
        data={users}
        isLoading={isLoading}
        columns={columns}
        pagination={true}
        count={pagination?.count}
        onChangePage={setPage}
        onPageSizeChange={setPageSize}
        page={page}
      />
    </div>
  );
};

export default CompanyUsers;
